import React from "react";
import KonselorControlDummy from "./KonselorControlDummy";
import { gmtClient } from "../../../../general/functions/datetimeFunction";
import TimmerPduli from "./TimmerPduli";
import useSessionDataPduli from "../../costumeHooks/useSessionDataPduli";
import { utcToClientDatetime } from "../../function/dateTimeCustomeFunction";

export default function VideoKonselingWatingOpen({ handleOpenRoom }) {
  const { dataSessionPduli } = useSessionDataPduli({});
  let momentClient = utcToClientDatetime(
    dataSessionPduli?.session?.date,
    dataSessionPduli?.session?.startTime
  );

  return (
    <div className="aspect-auto sm:aspect-[9/16]  h-screen bg-secondary-800">
      <div className="absolute top-0 h-full w-full   flex items-center justify-center border-8 border-black blur-3xl"></div>
      <div className="absolute w-[98%] m-1 bottom-1 p-2 bg-secondary-700 rounded-2xl opacity-50">
        <KonselorControlDummy />
      </div>
      <div className="absolute top-0 h-full w-full flex items-center justify-center">
        <div className="text-center">
          <p className="text-white text-lg">Panggilan Video</p>
          <p className="text-white text-lg">
            {momentClient.format("YYYY-MM-DD HH:mm:ss") + " " + gmtClient()}{" "}
          </p>
          <p className="text-white text-lg">Akan dimulai dalam:</p>
          <p className="text-white text-lg">
            {momentClient.format("YYYY-MM-DD HH:mm:ss") != null &&
              momentClient.format("YYYY-MM-DD HH:mm:ss") != undefined && (
                <TimmerPduli
                  endTime={momentClient.format("YYYY-MM-DD HH:mm:ss")}
                  setComplete={(v) => {
                    if (v) {
                      handleOpenRoom();
                    }
                  }}
                />
              )}
          </p>
        </div>
      </div>
    </div>
  );
}
